import _isEmpty from 'lodash/isEmpty';
import React, { Component } from 'react';
import numeral from 'numeral';
import chroma from 'chroma-js';
import { ResponsiveContainer, Treemap, Tooltip } from 'recharts';
import styles from './styles.scss';

class CustomizedContent extends Component {
  render() {
    const { children, depth, x, y, width, height, memoryScore, name } = this.props;

    const fill = _isEmpty(children) // eslint-disable-line no-nested-ternary
      ? memoryScore > 0
        ? chroma.scale(['#1a7ec15c', '#40b86c']).domain([0, 1]).mode('lch')(memoryScore)
        : '#d1d1d1'
      : 'rgba(255,255,255,0)';

    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill,
            stroke: '#fff',
            strokeWidth: 2 / (depth + 1e-10),
            strokeOpacity: 1 / (depth + 1e-10),
          }}
        />
        {depth === 1 ? (
          <text
            x={x + width / 2}
            y={y + height / 2 + 7}
            textAnchor="middle"
            fill="#fff"
            fontSize={14}
            className={styles.cellText}
          >
            {name}
          </text>
        ) : null}
      </g>
    );
  }
}

const CustomTooltipContent = (props) => {
  if (props.payload[0] != null) {
    const { name } = props.payload[0].payload;
    const items = `Items: ${props.payload[0].payload.value}`;
    const score = `Strength: ${numeral(props.payload[0].payload.memoryScore).format(
      '0%'
    )}`;

    return (
      <div className={styles.tooltip}>
        <div className={styles.title}>{name}</div>
        <div className={styles.description}>{items}</div>
        <div className={styles.description}>{score}</div>
      </div>
    );
  }

  return null;
};

const recursivelyAugmentContent = (content) => {
  const data = content.map((contentInstance) => ({
    name: contentInstance.name,
    memoryScore: contentInstance.memoryScore,
    size: contentInstance.numItems,
    children: recursivelyAugmentContent(contentInstance.content),
  }));
  return data;
};

class MemoryProgressTreemap extends Component {
  render() {
    const { inflatedContent } = this.props;

    const data = recursivelyAugmentContent(inflatedContent);

    return (
      <ResponsiveContainer width="99%" height={240}>
        <Treemap
          data={data}
          dataKey="size"
          ratio={4 / 3}
          stroke="#fff"
          fill="#8884d8"
          content={<CustomizedContent />}
          isAnimationActive={false}
          className="aaaMemoryTreemap"
        >
          <Tooltip content={<CustomTooltipContent />} />
        </Treemap>
      </ResponsiveContainer>
    );
  }
}

export default MemoryProgressTreemap;
